import React, {useRef, useState} from 'react';
import PropTypes from "prop-types";
import {TablaInformeCompensacionEvento} from "./TablaInformeCompensacionEvento";

export const InformeCompensacionEvento = ({ dataInicial ,dataFactura, dataAsociados, reload}) => {

    return(
        <>
            <TablaInformeCompensacionEvento dataInicial={dataInicial} factura={dataFactura} asociados={dataAsociados} reload={reload}/>
        </>

    )
}

InformeCompensacionEvento.prototype = {
    dataFactura: PropTypes.string,
    dataAsociados: PropTypes.array
}

InformeCompensacionEvento.defaultProps = {
    dataFactura: '',
    dataAsociados: []
}
